import React, { Component } from 'react';
import Dygraph from 'dygraphs/index.es5';
import { connect } from 'react-redux';

import { Paper } from '@material-ui/core';
import { Info as InfoIcon } from '@material-ui/icons';
import Tooltip from '@material-ui/core/Tooltip';
import '../../index.css';

import * as slowDataReducers from '../reducer';
import * as strings from '../../helpers/strings';

const styles = {
  graphCol: { 
    height: 710,
    position: "relative",
    overflow: 'auto', // Enable scrolling if content overflows
  },
  graphBG: { 
    background: "linear-gradient(0deg, #343A40, 0.4%, #F8F8F8 0.4%)", 
    padding: '40px',
    height: '100%',
  },
  graph: {
    left: 20,
    right: 20,
    top: 40,
    bottom: 10,
    height: 600,
  },
  legend: {
    marginBottom: '25px',
    textAlign: 'left',
    padding: '10px',
    borderRadius: '4px',
    display: 'flex',
    flexWrap: 'wrap',
  }
}

class DMYLineGraph extends Component {

  componentWillUnmount() {
    window.ipaDyLineGraph = null;
  }

  componentDidMount() {
    let options = {
      labels: [],
      strokeWidth: 3,
      highlightSeriesOpts: { 
        highlightCircleSize: 5,
        strokeWidth: 3.5
      },
      legend: 'always',
      labelsDiv: "legend",
      fillGraph: "True", 
      fillAlpha: 0.3
    };

    var graphElement = document.getElementById(strings.idIPAGraph);
    window.ipaDyLineGraph = new Dygraph(graphElement, [], options);
  }

  shouldComponentUpdate(nextProps) {
    const { dataSource } = nextProps;

    if (dataSource.data.length > 0) {
      window.ipaDyLineGraph.updateOptions({
        file: dataSource.data,
        labels: dataSource.lables,
        colors: dataSource.colors
      });
    } else {
      window.ipaDyLineGraph.updateOptions({
        file: [],
        labels: [],
        colors: []
      });
    }

    return false;
  }

  render() {
    return (
      <Paper style={styles.graphBG}>
        <div style={styles.graphCol}>
          <div id="legend" style={styles.legend}></div>
          <div id={strings.idIPAGraph} style={styles.graph} />
        </div>
        <div className="disclaimer-wrap">
          <Tooltip
            title={
              <div style={{ fontSize: '1rem', color: '#F8F8F8', lineHeight: '1.5em' }}>
                {strings.lblHistoryRecordsDisclaimer}
              </div>
            }
          >
            <InfoIcon className="disclaimer-icon" />
          </Tooltip>
        </div>   
      </Paper>
    )
  }
}

const mapStateToProps = state => ({
  dataSource: slowDataReducers.getGraphDataSourceV2(state),
  getSelectedField: slowDataReducers.getSelectedField(state),
})

export default connect(mapStateToProps)(DMYLineGraph);
